import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ActionIndicator from 'controls/action_indicator';

/**
 * A single step in the badge verification process
 *
 * @param {String} title - label text
 * @param {Any} data - the display data
 * @param {Object} status - A status object
 *   @param {Bool} pending - status.pending
 *   @param {Bool} succeeded - status.succeeded
 *   @param {Bool} failed - .failed
 * @param {Bool} pending - Higher order of precedence than status.pending
 * @param {Bool} succeeded - Higher order of precedence than status.succeeded
 * @param {Bool} failed - Higher order of precedence than status.failed
 */
class VerifyStep extends Component {
  pending = () => this.props.pending || (this.props.status && this.props.status.pending);
  succeeded = () => this.props.succeeded || (this.props.status && this.props.status.succeeded);
  failed = () => this.props.failed || (this.props.status && this.props.status.failed);


  render() {
    return (
      <li className="ac-verify-step">
        <div className="ac-verify-step__indicator">
          <ActionIndicator
            strictShow
            persist
            pending={this.pending()}
            succeeded={this.succeeded()}
            failed={this.failed()}
          />
        </div>
        <div className="ac-verify-step__description">
          <span className="ac-verify-step__title">
            { this.props.title }
          </span>
          <span className="ac-verify-step__data">
            { !this.pending() && this.succeeded()
              ? <span>{ this.props.data }</span> : <span>...</span>
            }
          </span>
        </div>
      </li>
    );
  }
}

VerifyStep.defaultProps = {
  status: {
    pending: false,
    succeeded: true,
    failed: false
  }
};

VerifyStep.propTypes = {
  title: PropTypes.string,
  data: PropTypes.any,
  status: PropTypes.shape({
    pending: PropTypes.bool,
    succeeded: PropTypes.bool,
    failed: PropTypes.bool
  }),
  pending: PropTypes.bool,
  succeeded: PropTypes.bool,
  failed: PropTypes.bool
};

export { VerifyStep };
